module.exports = __webpack_public_path__ + "static/media/Saptham.52083f79.svg";